export default "__VITE_ASSET__CGdyFr8i__"